import type enStrings from "./en";

const frStrings: typeof enStrings = {
  seo: {
    metaTitle: "Hexploit - et si créer des histoires devenait un jeu ?",
    metaKeywords:
      "Hexploit, jeu de société, cartes, boardgame, Dongeon et Dragons, DnD, narratif, storytelling, Kickstarter, collaboration, famille, jeu d'ambiance",
    metaDescription: "",
    ogTitle: "Hexploit - et si créer des histoires devenait un jeu ?",
  },
  whatIsHexploit: "C'est quoi Hexploit ?",
};

export default frStrings;
